import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import {
  useDeleteTableColumnMutation,
  useDeleteTableRowMutation,
  useFetchHeadersByRowIdMutation,
  useFetchValuesByRowIdMutation,
} from "../../utils/customer/customerTaskTable";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { pushAlert } from "../../utils/alertSlice";
import useRequireAuth from "../../utils/useRequireAuth";
import DeleteIcon from "../../assets/images/icons/deleteIcon";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import EditPencilIcon from "../../assets/images/icons/EditPencilIcon";
import { ReactComponent as BackArrow } from "../../assets/images/icons/BackIcon.svg";
import FloatingElement from "../UniversalComponents/FloatingElement";
import FloatingElementPortal from "../UniversalComponents/FloatingElementPortal";
import AddListDrawer from "./AddListDrawer";
import AddColumn from "./AddColumn";
import { ReactComponent as AddListIcon } from "../../assets/images/icons/AddList.svg";
import { ReactComponent as AddColumnIcon } from "../../assets/images/icons/AddColumn.svg";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";

const ManageListDetails = ({ listData, handleBackClick }) => {
  const dispatch = useDispatch();
  const { token } = useRequireAuth();
  const [tableHeaders, setTableHeaders] = useState([]);
  const [tableBodyData, setTableBodyData] = useState([]);
  const [floatingOpen, setFloatingOpen] = useState();
  const [openAddList, setOpenAddList] = useState(false);
  const [openAddColumn, setOpenAddColumn] = useState(false);
  const [addEditManageList, setAddEditManageList] = useState("");
  const [editColumnData, setEditColumnData] = useState();
  const [selecteduserId, setSelecteduserId] = useState(null);
  const [editListData, setEditListData] = useState({});
  const cellRef = useRef(null);
  const [showRowConfirmation, setShowRowConfirmation] = useState(false);
  const [choiceToRowDelete, setChoiceToRowDelete] = useState(null);
  const [showColumnConfirmation, setShowColumnConfirmation] = useState(false);
  const [choiceToColumnDelete, setChoiceToColumnDelete] = useState(null);
  // const [primaryData, setPrimaryData] = useState({});
  const [isAddRowColumnActive, setIsAddRowColumnActive] = useState(false);

  const [
    fetchHeadersByRowId,
    {
      data: headersResponseData,
      isError: isHeadersError,
      isSuccess: isHeadersSuccess,
      isLoading: isHeadersLoading,
      error: headerResponseError,
    },
  ] = useFetchHeadersByRowIdMutation();

  const [
    fetchValuesByRowId,
    { data: valuesResponseData, isError: isValuesError, isSuccess: isValuesSuccess, isLoading: isValuesLoading },
  ] = useFetchValuesByRowIdMutation();

  useEffect(() => {
    if (listData?.id) {
      handleRowClick(listData);
    }
  }, [listData]);

  useEffect(() => {
    if (isHeadersLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isHeadersSuccess && headersResponseData?.status) {
      // dispatch(pushAlert({
      //   message: headersResponseData?.message || "Headers fetched successfully",
      //   type: "success",
      //   visible: true,
      // }));
      const StaticHeader = [
        {
          accessor_key: "row_id",
          label: "Id",
          id: "row_id",
        },
      ];
      const newHeaders = createColumnDefinitions(headersResponseData?.data || []);
      // setPrimaryData([...StaticHeader, ...newHeaders]);
      setTableHeaders([...StaticHeader, ...newHeaders]);
    }

    if (isHeadersError) {
      dispatch(
        pushAlert({
          message: headerResponseError?.message || "Headers operation failed",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isHeadersSuccess, isHeadersError, isHeadersLoading]);

  function flattenApiDataArray(apiResponse) {
    if (!apiResponse || !apiResponse.status || !Array.isArray(apiResponse.data)) {
      return [];
    }

    return apiResponse.data.map((row) => {
      const flatRow = { row_id: row.row_id };
      const rowData = row.data;

      for (const key in rowData) {
        if (rowData.hasOwnProperty(key) && typeof rowData[key] === "object" && "value" in rowData[key]) {
          flatRow[key] = rowData[key].value;
        }
      }

      return flatRow;
    });
  }

  useEffect(() => {
    if (isValuesLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isValuesSuccess && valuesResponseData?.status) {
      // dispatch(pushAlert({
      //   message: valuesResponseData?.message || "Values fetched successfully",
      //   type: "success",
      //   visible: true,
      // }));
      setTableBodyData(flattenApiDataArray(valuesResponseData));
    }

    if (isValuesError) {
      dispatch(
        pushAlert({
          message: valuesResponseData?.message || "Values operation failed",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isValuesSuccess, isValuesError, isValuesLoading]);

  const handleRowClick = (listData) => {
    const rowId = listData?.id;

    fetchHeadersByRowId({ token, rowId });
    fetchValuesByRowId({ token, rowId });
  };

  const createColumnDefinitions = (headersData) => {
    return headersData.map((header) => ({
      accessor_key: header?.value,
      label: header?.label,
      metaData: header,
    }));
  };

  const handleAddButtonClick = () => {
    setFloatingOpen(true);
    setIsAddRowColumnActive(true);
  };

  const handleCloseFloating = () => {
    setFloatingOpen(false);
  };

  const handleAddList = () => {
    setOpenAddList(true);
    setFloatingOpen(false);
    setIsAddRowColumnActive(false);
    setEditListData({});
  };

  const handleAddColumn = () => {
    setOpenAddColumn(true);
    setFloatingOpen(false);
    setIsAddRowColumnActive(false);
  };

  const handleAddEditManageList = (item) => {
    setOpenAddList(true);
    setEditListData(item);
  };
  const [
    deleteTableRow,
    { data: deletedRowData, isError: isDeleteRowError, isSuccess: isDeleteRowSuccess, isLoading: isDeleteRowLoading },
  ] = useDeleteTableRowMutation();

  const handleDeleteRow = (rowData) => {
    const rowId = rowData?.row_id;
    const tableId = listData?.id;
    deleteTableRow({ token, tableId, rowId });
  };

  useEffect(() => {
    if (isDeleteRowLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (isDeleteRowSuccess) {
      dispatch(
        pushAlert({
          message: deletedRowData?.message,
          type: "success",
          visible: true,
        })
      );
      if (deletedRowData?.status) {
        handleRowClick(listData);
      }
    }
    // catch block
    if (isDeleteRowError) {
      dispatch(pushAlert({ message: deletedRowData?.message, type: "danger", visible: true }));
    }
  }, [isDeleteRowSuccess, isDeleteRowError, isDeleteRowLoading]);

  const [
    deleteTableColumn,
    {
      data: deletedColumnData,
      isError: isDeleteColumnError,
      isSuccess: isDeleteColumnSuccess,
      isLoading: isDeleteColumnLoading,
    },
  ] = useDeleteTableColumnMutation();

  const handleColumnDelete = (column) => {
    const columnId = column?.column?.columnDef?.meta?.id;
    const tableId = listData?.id;
    deleteTableColumn({ token, tableId, columnId });
  };

  useEffect(() => {
    if (isDeleteColumnLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (isDeleteColumnSuccess) {
      dispatch(
        pushAlert({
          message: deletedColumnData?.message,
          type: "success",
          visible: true,
        })
      );
      if (deletedColumnData?.status) {
        handleRowClick(listData);
      }
    }
    // catch block
    if (isDeleteColumnError) {
      dispatch(pushAlert({ message: deletedColumnData?.message, type: "danger", visible: true }));
    }
  }, [isDeleteColumnSuccess, isDeleteColumnError, isDeleteColumnLoading]);

  const handleConfirmRowDelete = () => {
    if (choiceToRowDelete) {
      handleDeleteRow(choiceToRowDelete);
    }
    setShowRowConfirmation(false);
    setChoiceToRowDelete(null);
  };

  const handleRowDelete = (rowData) => {
    setChoiceToRowDelete(rowData);
    setShowRowConfirmation(true);
  };

  const handleConfirmColumnDelete = () => {
    if (choiceToColumnDelete) {
      handleColumnDelete(choiceToColumnDelete);
    }
    setShowColumnConfirmation(false);
    setChoiceToColumnDelete(null);
  };

  const handleDeleteColumn = (column) => {
    setChoiceToColumnDelete(column);
    setShowColumnConfirmation(true);
  };

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return (
    <div className="flex flex-col grow min-h-0 w-full">
      <ReactTableComponent
        tablename={
          <p className="text-2C495D font-600">
            {
              <span onClick={handleBackClick} className="cursor-pointer flex items-center gap-2">
                {" "}
                <BackArrow /> {listData?.list_name}
              </span>
            }
          </p>
        }
        headers={tableHeaders}
        body={tableBodyData}
        isColumnDelete
        // handleColumnDelete={handleColumnDelete}
        handleColumnDelete={handleDeleteColumn}
        isShowEmptyHeader
        actionField={
          <>
            {floatingOpen && (
              <FloatingElementPortal
                open={floatingOpen}
                onClose={() => {
                  setFloatingOpen(false);
                  setIsAddRowColumnActive(false);
                }}
                containerRef={cellRef}
                mode="vertical"
                xMargin={-50}
              >
                <div className="w-40 bg-white rounded-lg border shadow-[0px_4px_8px_rgba(0,0,0,0.1)] flex flex-col py-2">
                  {headersResponseData?.data?.length > 0 && (
                    <button
                      onClick={handleAddList}
                      type="button"
                      className="flex items-center gap-2 px-4 py-2 text-[#8A8A8A] hover:text-[#1D4469] hover:bg-gray-100 font-medium text-sm transition-colors duration-150 group"
                    >
                      <AddListIcon className="fill-[#8A8A8A] group-hover:fill-[#1D4469]" />
                      Add List
                    </button>
                  )}

                  <button
                    onClick={handleAddColumn}
                    type="button"
                    className="flex items-center gap-2 px-4 py-2 text-[#8A8A8A] hover:text-[#1D4469] hover:bg-gray-100 font-medium text-sm transition-colors duration-150 group"
                  >
                    <AddColumnIcon className="fill-[#8A8A8A] group-hover:fill-[#1D4469]" />
                    Add Column
                  </button>
                </div>
              </FloatingElementPortal>
            )}
            <div className="flex gap-1 " ref={cellRef}>
              <button
                onClick={() => handleAddButtonClick({ type: "add" })}
                type="button"
                className="cursor-pointer border border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
              >
                <PlusIcon isHovere={""} isActive={isAddRowColumnActive} />
              </button>
            </div>
          </>
        }
        actionColumn={(item) => {
          return (
            <div className="flex items-center gap-4">
              <button
                // onClick={() => handleDeleteRow(item)}
                onClick={() => handleRowDelete(item)}
                type="button"
              >
                <DeleteIcon color={"red"} size={18} />
              </button>

              <button onClick={() => handleAddEditManageList(item)}>
                <EditPencilIcon
                  color={"#203C50"}
                  size={18}
                  closeButton={openAddList}
                  className="text-[#969BA9] hover:text-[#1D4469] cursor-pointer"
                />
              </button>
            </div>
          );
        }}
      />
      {openAddList && (
        <AddListDrawer
          open={openAddList}
          onClose={() => setOpenAddList(false)}
          editListData={editListData}
          setEditListData={setEditListData}
          headersResponseData={headersResponseData?.data}
          tableData={listData}
          handleRowClick={handleRowClick}
        />
      )}

      {openAddColumn && (
        <AddColumn
          tableData={listData}
          open={openAddColumn}
          closePopup={() => setOpenAddColumn(false)}
          handleRowClick={handleRowClick}
          editColumnData={editColumnData}
        />
      )}

      {showRowConfirmation && (
        <ConfirmationDialog
          open={showRowConfirmation}
          onConfirm={handleConfirmRowDelete}
          onClose={() => {
            setShowRowConfirmation(false);
            setChoiceToRowDelete(null);
          }}
          title="Delete"
          message={
            <>
              Are you sure you want to delete data with row Id{" "}
              <span className="font-semibold">{getOrdinal(choiceToRowDelete?.row_id)}</span> permanently ?
            </>
          }
          confirmVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}
      {showColumnConfirmation && (
        <ConfirmationDialog
          open={showColumnConfirmation}
          onConfirm={handleConfirmColumnDelete}
          onClose={() => {
            setShowColumnConfirmation(false);
            setChoiceToColumnDelete(null);
          }}
          title="Delete"
          message={
            <>
              Are you sure you want to delete{" "}
              <span className="font-semibold">{choiceToColumnDelete?.column?.columnDef?.header}</span> Column from all
              row permanently ?
            </>
          }
          confirmVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}
    </div>
  );
};

export default ManageListDetails;
